import gql from "graphql-tag";

export default {
  update: gql`
    mutation UpdateWheel2Cell ($input: UpdateWheel2CellInput!) {
      updateWheel2Cell (input: $input) {
        id
        cell_type
        wheel_uri
        arrow_uri
        background_uri
        sound_uri
        title_text
        accent_color
        config
      }
    }`,

  get: gql`
    query Wheel2Cell($id: ID!) {
      wheel2Cell(id: $id) {
        id
        cell_type
        wheel_uri
        arrow_uri
        background_uri
        sound_uri
        title_text
        accent_color
        config
      }
    }`,

  stats: gql`
    query Wheel2Stats($id: ID!, $stock_version: Int) {
      wheel2Stats(id: $id, stock_version: $stock_version) {
        prize_key
        count
      }
    }`,

  plays: gql`
    query Wheel2Plays($id: ID!, $stock_version: Int) {
      wheel2Plays(id: $id, stock_version: $stock_version) {
        id
        device_id
        played_at
        prize_key
        player_data
      }
    }`
}
